import { fireEventGTM } from '../modules/marketing/gtm.js';
import { normalizeString } from '../modules/tools.js';
import EgoForm from '@egodesign/form';
import EgoModal from '@egodesign/modal';
import { getCSRFTokenValue, getRecaptchaToken } from '../modules/form-helpers'

const recommender = document.querySelector('.recommender');
const backToTop = () => document.querySelector('.back-to-top')?.click();

if (recommender) {
    /////////////////
    // STEPS
    const totalSteps = 5;
    const stepCards = {
        card_1: recommender.querySelector('.step-card[data-step-card="1"]'),
        card_2: recommender.querySelector('.step-card[data-step-card="2"]'),
        card_3: recommender.querySelector('.step-card[data-step-card="3"]'),
        card_4: recommender.querySelector('.step-card[data-step-card="4"]'),
        card_5: recommender.querySelector('.step-card[data-step-card="5"]'),
    }
    const stepNames = {
        1: 'seleccionar_etapa',
        2: 'seleccionar_familia',
        3: 'nuestra_recomendación',
        4: 'finalizar_solicitud',
        5: 'solicitud_enviada',
    }
    let activeStep = 1;

    // Functions
    const changeStep = (step) => {
        let nextStepNumber = step === 'next' ? activeStep + 1
            : step === 'prev' ? activeStep - 1
                : step;

        if (nextStepNumber > totalSteps) nextStepNumber = totalSteps;
        if (nextStepNumber < 1) nextStepNumber = 1;
        goToStep(nextStepNumber);
    }

    const goToStep = (step) => {
        const stepCard = recommender.querySelector(`.step-card[data-step-card="${step}"]`);

        if (stepCard) {
            if (step === 3 && activeStep < 3) resetStep3();
            if (step === 4) updateFormFields();

            recommender.querySelector(`.step.--active`)?.classList.remove('--active');
            recommender.querySelector(`.step-card.--active`)?.classList.remove('--active');
            recommender.querySelector(`.step[data-step="${step}"]`)?.classList.add('--active');
            stepCard.classList.add('--active');
            backToTop();
        }

        if (step <= 4) {
            fireEventGTM('recommender', {
                step_form: `{${step}}`,
                step_name: `{${stepNames[step]}}`,
                nombre_formulario: '{oil_and_gas}',
                eventLabel: window.location.href
            });
        } else if (step === 5) {
            fireEventGTM('formulario_enviado', {
                eventCategory: 'formulario_oil_gas',
                nombre_formulario: '{oil_and_gas}',
                timestamp_custom: Math.floor(Date.now() / 1000).toString(),
                eventLabel: window.location.href
            });
        }

        activeStep = step;
    }

    const restartRecommender = () => {
        changeStep(1);
        resetStep3();
        stepCards.card_3.querySelectorAll('.recommender__chooser__button').forEach((btn) => {
            btn.classList.add('--hide');
        })
        recommender.querySelectorAll('[type="checkbox"]:checked').forEach(check => {
            check.checked = false;
        });
    }


    // Step change Listeners
    recommender.querySelectorAll('.recommender__btn--next').forEach(btn => {
        btn.addEventListener('click', () => changeStep('next'));
    });
    recommender.querySelectorAll('.recommender__btn--prev').forEach(btn => {
        btn.addEventListener('click', () => changeStep('prev'));
    });
    recommender.querySelectorAll('.recommender__restart').forEach(btn => {
        btn.addEventListener('click', restartRecommender);
    });


    // Steps checker
    stepCards.card_1.querySelectorAll('.card-recommender-stage [type="checkbox"]')
        .forEach(input => {
            input.addEventListener('change', () => {
                const isValid = stepCards.card_1.querySelectorAll('.card-recommender-stage [type="checkbox"]:checked').length >= 1;
                if (!isValid) {
                    stepCards.card_1.querySelector('.recommender__btn--next').classList.add('--disabled');
                } else {
                    stepCards.card_1.querySelector('.recommender__btn--next').classList.remove('--disabled');
                }
            })
        });

    stepCards.card_2.querySelectorAll('.card-recommender-family [type="checkbox"]')
        .forEach(input => {
            input.addEventListener('change', () => {
                // Set next button state
                const isValid = stepCards.card_2.querySelectorAll('.card-recommender-family [type="checkbox"]:checked').length >= 1;
                if (!isValid) {
                    stepCards.card_2.querySelector('.recommender__btn--next').classList.add('--disabled');
                } else {
                    stepCards.card_2.querySelector('.recommender__btn--next').classList.remove('--disabled');
                }

                // Show/Hide tabs in step 3
                const tabBtn = stepCards.card_3.querySelector(`[for="tab_${input.name}"]`);
                const tab = stepCards.card_3.querySelector(`[data-tab-name="${input.name}"]`);
                if (tabBtn && tab) {
                    if (input.checked) {
                        tabBtn.classList.remove('--hide');
                        tab.classList.remove('--hide');
                    } else {
                        tabBtn.classList.add('--hide');
                        tab.classList.add('--hide');
                    }
                }
            })
        });

    const resetStep3 = () => {

        // Reset all and set active tab button
        stepCards.card_3.querySelectorAll('.recommender__chooser__buttons label input').checked = false;
        const activeInput = stepCards.card_3.querySelector('.recommender__chooser__buttons label:not(.--hide) input');
        activeInput.checked = true;
        const activeButton = activeInput.value;

        //Reset all and set active Tab
        stepCards.card_3.querySelectorAll('.recommender__chooser__tab')
            .forEach(tab => {
                tab.classList.add('--hide');
                tab.classList.remove('--active');
            });

        const activeTab = stepCards.card_3.querySelector(`.recommender__chooser__tab[data-tab="${activeButton}"]`);
        activeTab.classList.add('--active');
        activeTab.classList.remove('--hide');


        // Reset all subfamilies
        stepCards.card_3.querySelectorAll('.card-recommender-subfamily [type="checkbox"]')
            .forEach(input => input.checked = false);
        // Reset select all
        stepCards.card_3.querySelectorAll('.select-all').forEach(input => input.checked = false);
        // Reset summary lists
        recommender.querySelectorAll(`.recommender__summary__body ul`).forEach(ul => ul.innerHTML = '');
        // Hide summary
        stepCards.card_3.querySelector('.recommender__summary').classList.add('--hidden');
        stepCards.card_3.querySelector('.recommender__summary__empty').classList.remove('--hidden');
    }

    const checkStep3 = () => {
        const isValid = stepCards.card_3.querySelectorAll('.card-recommender-subfamily [type="checkbox"]:checked').length >= 1;
        if (!isValid) {
            stepCards.card_3.querySelector('.recommender__btn--next').classList.add('--disabled');
            stepCards.card_3.querySelector('.recommender__summary').classList.add('--hidden');
            stepCards.card_3.querySelector('.recommender__summary__empty').classList.remove('--hidden');
        } else {
            stepCards.card_3.querySelector('.recommender__btn--next').classList.remove('--disabled');
            stepCards.card_3.querySelector('.recommender__summary').classList.remove('--hidden');
            stepCards.card_3.querySelector('.recommender__summary__empty').classList.add('--hidden');
        }
    }
    stepCards.card_3.querySelectorAll('.card-recommender-subfamily [type="checkbox"]')
        .forEach(input => { input.addEventListener('change', checkStep3) });


    // Filter input step 3
    const filterInput = recommender.querySelector('.recommender__filter__input-container input');
    const cleanValue = recommender.querySelector('.recommender__filter__clean-value');
    let debouncer, filterTearm = '';

    cleanValue.addEventListener('click', () => {
        filterInput.value = '';
        cleanValue.classList.remove('--show');
        filterTearm = '';
        filterSubfamilies();
    });

    filterInput.addEventListener('input', () => { handleInput(filterInput.value); });
    filterInput.addEventListener('paste', () => { handleInput(filterInput.value); });

    const handleInput = value => {
        if (!value) {
            cleanValue.classList.remove('--show');
        } else {
            cleanValue.classList.add('--show');
        }

        clearTimeout(debouncer);
        debouncer = setTimeout(() => {
            filterTearm = normalizeString(value);
            filterSubfamilies();
        }, 500);
    }

    const filterSubfamilies = () => {
        const subfamilies = stepCards.card_3.querySelectorAll('.card-recommender-subfamily');
        subfamilies.forEach(subfamily => {
            if (normalizeString(subfamily.title).includes(filterTearm)) {
                subfamily.classList.remove('--hidden');
            } else {
                subfamily.classList.add('--hidden');
            }
        })
    }


    ////////////////////
    // Subfamily chooser

    // Chooser tabs
    const chooser = recommender.querySelector('.recommender__chooser');
    chooser.querySelectorAll('input[name="tabs"]').forEach(input => {
        input.addEventListener('change', () => {
            changeChooserTab(input.value);
        })
    });

    const changeChooserTab = tab => {
        const current = chooser.querySelector('.recommender__chooser__tab.--active');
        current.classList.remove('--active');
        setTimeout(() => {
            chooser.querySelectorAll('.recommender__chooser__tab').forEach(tab => {
                tab.classList.add('--hide');
            });
            const next = chooser.querySelector('.recommender__chooser__tab[data-tab="' + tab + '"]');
            next.classList.remove('--hide');
            next.classList.add('--active');
        }, 200);
    }

    // Select all
    const changeEvent = new Event('change');
    chooser.querySelectorAll('input.select-all').forEach(input => {
        input.addEventListener('change', () => {
            chooser.querySelectorAll(`[data-name="${input.name}"] input[type="checkbox"]`).forEach(checkbox => {
                checkbox.checked = input.checked;
                checkbox.dispatchEvent(changeEvent);
                checkStep3();
            });
        })
    });

    chooser.querySelectorAll('.cards input[type="checkbox"]').forEach(input => {
        input.addEventListener('change', () => {
            const familyDetailBox = recommender.querySelectorAll(`.recommender__summary__body[data-family="${input.dataset.family}"] ul`);

            if (input.checked) {
                if (!recommender.querySelector(`li[data-subfamily="${input.dataset.subfamily}"]`)) {
                    const li = document.createElement('li');
                    li.dataset.subfamily = input.dataset.subfamily;
                    li.textContent = input.value;
                    familyDetailBox.forEach(el => el.appendChild(li.cloneNode(true)));
                }
            } else {
                const all = chooser.querySelector(`input[name="${input.closest('.cards').dataset.name}"]`);
                if (all) all.checked = false;

                recommender.querySelectorAll(`li[data-subfamily="${input.dataset.subfamily}"]`)
                    .forEach(li => li.remove());
            }
        })
    })

    ////////////////
    // FORM
    const formContactElement = document.querySelector('#recommenderForm');
    const modalElement = document.querySelector('#modal-recommender-error');
    const modalRecommenderError = new EgoModal({
        element: modalElement
    });
    modalElement.querySelector('.modal-close').addEventListener('click', () => {
        modalRecommenderError.close();
    });

    const csrf = getCSRFTokenValue(formContactElement);
    const recommenderForm = new EgoForm({
        element: formContactElement,
        submitType: 'fetch',
        debug: false,
        requestHeaders: {
            'X-CSRFToken': csrf,
        },
        customValidationMessages: {
            default: {
                empty: 'Campo requerido.',
                invalid: 'Campo nó válido.',
                minLength: 'Min. [[var]] caracteres.',
                maxLength: 'Máx. [[var]] caracteres.',
            },
            categories: {
                empty: 'Seleccioná al menos una opción',
            },
            actions: {
                empty: 'Seleccioná al menos una opción',
            },
            cuit: {
                empty: 'Campo requerido.',
                invalid: 'Revisá este CUIT',
            },
            cuit_cuil: {
                empty: 'Campo requerido.',
                invalid: 'Revisá este CUIT',
            },
        },
        customValidations: {
            phone_sum: [
                {
                    name: 'phone_sum',
                    condition: (value) => {
                        const codeAreaVal = formContactElement.querySelector('#contactAreaInput')?.value
                        return value.length + codeAreaVal.length === 10
                    },
                    message: 'Revisá este número y el código de área',
                },
            ],
            cuit_cuil: [
                {
                    name: 'cuit_cuil',
                    condition: (cuit) => {
                        if (cuit.length < 11 || cuit.length > 13) return false;
                        let rv = false;
                        let resultado = 0;
                        let cuit_nro = cuit.replace("-", "");
                        const codes = "6789456789";
                        let verificador = parseInt(cuit_nro[cuit_nro.length - 1]);
                        let x = 0;

                        while (x < 10) {
                            let digitoValidador = parseInt(codes.substring(x, x + 1));
                            if (isNaN(digitoValidador)) digitoValidador = 0;
                            let digito = parseInt(cuit_nro.substring(x, x + 1));
                            if (isNaN(digito)) digito = 0;
                            let digitoValidacion = digitoValidador * digito;
                            resultado += digitoValidacion;
                            x++;
                        }
                        resultado = resultado % 11;
                        rv = (resultado == verificador);
                        return rv;
                    },
                    message: 'Revisá este CUIT',
                },
            ],
        },
        onError: () => modalRecommenderError.open(),
        onSuccess: () => changeStep(5),
        onBeforeSubmit: async () => {
            recommenderForm.submittingForm(true);
            const recaptchaToken = await getRecaptchaToken();
            if (recaptchaToken) {
                recommenderForm.extraFields.push({
                    name: 'recaptcha_token',
                    value: recaptchaToken
                })
                recommenderForm.resumeSubmit();
            } else {
                recommenderForm.submittingForm(false);
                recommenderForm.onError();
            }
        },
        preventSubmit: true,
    });

    const updateFormFields = () => {
        const inputStages = formContactElement.querySelector('input[name="stages"]'),
            inputActions = formContactElement.querySelector('input[name="actions"]'),
            inputCategories = formContactElement.querySelector('input[name="categories"]'),
            inputLines = formContactElement.querySelector('input[name="lines"]'),
            actionChecks = stepCards.card_1.querySelectorAll('input[type="checkbox"]:checked');

        // Collect stages
        const stages = [];
        actionChecks.forEach(check => {
            if (check.dataset.stage) {
                stages.push(check.dataset.stage);
            }
        });
        inputStages.value = stages.join(';');

        // Collect actions
        const actions = [];
        actionChecks.forEach(check => actions.push(check.name));
        inputActions.value = [...new Set(actions)].join(';');

        // Collect categories
        const categories = [];
        stepCards.card_2.querySelectorAll('.card-recommender-family input[type="checkbox"]:checked').forEach(check => {
            categories.push(check.value);
        });
        inputCategories.value = categories.join(';');

        // Collect lines
        const lines = [];
        stepCards.card_3.querySelectorAll('.card-recommender-subfamily input[type="checkbox"]:checked').forEach(check => {
            lines.push(check.value);
        });
        inputLines.value = lines.join(';');
    }

    // Handle form fields
    const selectLineType = formContactElement.querySelector('#contactLineInput')
    if (selectLineType) {
        selectLineType.addEventListener('change', (e) => {
            // limpia número de teléfono
            const phoneNumberInput = formContactElement.querySelector('#contactPhoneInput')
            phoneNumberInput.value = ''

            const alert = formContactElement.querySelector('#contactPhoneInputAlert')
            const internField = formContactElement.querySelector('#contactInternInput')

            if (e.target.value == 'movil') {
                alert.style.display = 'block'
                internField.disabled = true
                internField.value = ''
                internField.parentElement.classList.remove('--filled')
            } else {
                alert.style.display = 'none'
                internField.disabled = false
            }
        })
    }

    document.querySelectorAll('.no-leading-zero')?.forEach((input) => {
        input.addEventListener('input', (e) => {
            if (e.target.value?.toString().charAt(0) === '0') {
                const alert = input.parentElement.querySelector('.form__alert')
                if (alert) {
                    alert.classList.remove('--hidden')
                }
            }
            input.value = input.value.replace(/\b0+/g, '')
        })
        input.addEventListener('paste', (e) => {
            if (e.target[0] == 0) {
                const alert = input.parentElement.querySelector('.form__alert')
                if (alert) {
                    alert.classList.remove('--hide')
                }
            }
            input.value = input.value.replace(/\b0+/g, '')
        })
    })

    document.querySelectorAll('.no-leading-15')?.forEach((input) => {
        input.addEventListener('input', (e) => {
            if (selectLineType?.value === 'movil') {
                const val = e.target.value.toString()
                if (val.length > 1 && val.charAt(0) === '1' && val.charAt(1) === '5') {
                    const alert = input.parentElement.querySelector('.form__alert')
                    if (alert) {
                        alert.classList.remove('--hidden')
                    }
                }
                input.value = input.value.replace(/\b15+/g, '')
            }
        })
        input.addEventListener('paste', (e) => {
            if (selectLineType?.value === 'movil') {
                const val = e.target.value.toString()
                if (val.length > 1 && val.charAt(0) === '1' && val.charAt(1) === '5') {
                    const alert = input.parentElement.querySelector('.form__alert')
                    if (alert) {
                        alert.classList.remove('--hidden')
                    }
                }
                input.value = input.value.replace(/\b15+/g, '')
            }
        })
    })


    // EVENTS
    let eventsStart = false;
    recommender.querySelectorAll('.card-recommender-stage [type="checkbox"]')
        .forEach(input => {
            input.addEventListener('change', () => {
                if (!eventsStart) {
                    eventsStart = true;
                    fireEventGTM('recommender', {
                        step_form: '{1}',
                        step_name: `{${stepNames[1]}}`,
                        nombre_formulario: '{oil_and_gas}',
                        eventLabel: window.location.href
                    });
                }
            })
        });

}
